import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useCustomerAuth } from "@/context/CustomerAuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { processSession } = useCustomerAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const params = new URLSearchParams(location.hash.replace("#", ""));
    const sessionId = params.get("session_id");
    const dest = localStorage.getItem("oyebest_post_login") || "/";
    localStorage.removeItem("oyebest_post_login");
    if (!sessionId) { navigate("/", { replace: true }); return; }
    processSession(sessionId)
      .then(() => navigate(dest, { replace: true }))
      .catch(() => navigate("/", { replace: true }));
  }, [location, navigate, processSession]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-3">
      <Loader2 className="w-7 h-7 animate-spin text-primary" />
      <p className="text-muted-foreground">Signing you in…</p>
    </div>
  );
}
